module.exports = __webpack_public_path__ + "static/media/PushtimargImage38.5f386ef7.jpg";